import { IGetTopBetsByAnnouncementResponse } from '../../../../repositories/auction/v2/get-top-bets-by-announcement';
import { ITopBets } from '../../../../redux/reducers/topBets';
import { mapBetLeaders } from './mapBetLeaders';

export function mapTopBets(response: IGetTopBetsByAnnouncementResponse): ITopBets {
  const { topAnnouncementsBets, actualDataDate, serpUrl } = response;

  const leaders = mapBetLeaders(topAnnouncementsBets);

  return {
    leaders,
    requestDateTime: actualDataDate,
    serpUrl,
  };
}
